module.exports = __webpack_public_path__ + "static/media/item_01.640ba46d.jpg";